import { render, staticRenderFns } from "./offers.vue?vue&type=template&id=e3ffb524&scoped=true&"
import script from "./offers.vue?vue&type=script&lang=js&"
export * from "./offers.vue?vue&type=script&lang=js&"
import style0 from "./offers.vue?vue&type=style&index=0&id=e3ffb524&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3ffb524",
  null
  
)

export default component.exports